<template>
    <section>
        <form @submit.prevent :class="{ 'has-image-previews': preview_list.length > 0 }">
            <p>{{ isBestandsaufnahme ? 'Bestandsaufnahme' : 'Neues Protokoll' }}</p>
            <!-- <label for="datepicker">Datum</label>
            <input type="date" name="datepicker" data-bs-class="datepicker" data-date-format="dd/mm/yyyy"
                v-model="reportDate" disabled /> -->
            <label for="objket-name">Objekt</label>
            <input type="text" name="objket-name" v-model="objektName" />
            <label for="protokol-type">Protokolltyp</label>
            <input
                v-if="isBestandsaufnahme"
                type="text"
                id="protokol-type"
                name="protokol-type"
                :value="protokolType"
                disabled
            />
            <select v-else name="protokol-type" id="protokol-type" v-model="protokolType">
                <!-- <option value="none">none</option> -->
                <option value="Wöchentliche Reinigung">Wöchentliche Reinigung</option>
                <option value="Sonderreinigung">Sonderreinigung</option>
                <option value="Entrümpelung">Entrümpelung</option>
                <option value="Winterdienst">Winterdienst</option>
                <option value="Grünpflege">Grünpflege</option>
                <option value="Sonstige">Sonstige</option>
            </select>
            <div class="card-wrapper">
                <div class="card">
                    <div class="top">
                        <p>Bilder hochladen</p>
                        <!-- <button type="button" @click="uploadFiles">
                            Upload
                        </button> -->
                    </div>
                    <div class="drag-area">
                        <div v-if="isNativePicker" class="native-pick-actions">
                            <button type="button" class="native-pick-btn" @click="pickFromGallery">
                                Aus Galerie
                            </button>
                            <button type="button" class="native-pick-btn" @click="pickFromCamera">
                                Kamera
                            </button>
                        </div>
                        <template v-else>
                            <label for="uploadmyfile" class="dropArea">
                                <span class="on-drop">Nutze drag-n-drop oder klicke hier</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" fill="currentColor"
                                    class="bi bi-camera-fill" viewBox="0 0 16 16">
                                    <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                    <path
                                        d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
                                </svg>
                            </label>
                            <input name="images" type="file" class="file" id="uploadmyfile" ref="fileInput" multiple="multiple"
                                @change="requestUploadFile" accept="image/*" />
                        </template>
                    </div>
                    <p v-if="preview_list.length" class="sort-hint">
                        Reihenfolge per Ziehen ändern. Bilder mit dem Pfeil drehen.
                    </p>

                    <!-- IMAGE PREVIEW CONTAINER -->

                    <!-- <div class="container">
                        <div class="imagePreviewWrapper" @click="selectImage" @dragenter.prevent @dragover.prevent>
                            <template v-if="preview_list.length">
                                <div v-for="(item, index) in preview_list" :key="index" class="previewImgContainer"
                                    @dragstart="startDrag($event, index)" @drop="onDrop($event, index)">
                                    <img :src="item" class="img-fluid" />
                                    <p class="display-index">
                                        {{ index + 1 }}
                                    </p>
                                    <p class="display-delete-icon" @click="deleteImage(index)">
                                        <font-awesome-icon icon="fa-trash-can" />
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div> -->
                    <div v-if="preview_list.length" class="container">
                        <div class="imagePreviewWrapper" @dragenter.prevent @dragover.prevent>
                            <div
                                v-for="(item, index) in preview_list"
                                :key="index"
                                class="previewImgContainer"
                                :class="{ 'is-rotating': rotatingIndexes[index] }"
                                :data-image-index="index"
                                draggable="true"
                                @dragstart="startDrag($event, index)"
                                @drop="onDrop($event, index)"
                                @touchstart="onTouchStart($event, index)"
                                @touchmove="onTouchMove"
                                @touchend="onTouchEnd"
                                @touchcancel="onTouchCancel"
                                @contextmenu.prevent
                            >
                                <img
                                    :src="item"
                                    class="img-fluid"
                                    draggable="false"
                                    @contextmenu.prevent
                                />
                                <p class="display-index">
                                    {{ index + 1 }}
                                </p>
                                <p
                                    class="display-rotate-icon"
                                    title="Bild drehen"
                                    @click.stop="rotatePreviewImage(index)"
                                    @mousedown.stop
                                    @touchstart.stop
                                    @contextmenu.prevent
                                >
                                    <font-awesome-icon icon="fa-rotate-right" />
                                </p>
                                <p
                                    class="display-delete-icon"
                                    @click.stop="deleteImage(index)"
                                    @mousedown.stop
                                    @touchstart.stop
                                    @contextmenu.prevent
                                >
                                    <font-awesome-icon icon="fa-trash-can" />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button v-if="currentPrtokolId !== ''" @click="protokoListPreview">Öffnen</button>
                <button @click="uploadFiles('In Bearbeitung')" :disabled="!isOnline">
                    Protokoll zwischenspeichern
                </button>
                <button @click="uploadFiles('Abgeschlossen')" :disabled="!isOnline">Abschließen</button>
            </div>
        </form>
        <modal-loader-window :displayModalLodaer="showModalLoader" :timeout="3000" @close="closeModalLoader">
            <template #body>
                <span v-html="percentage"></span>
            </template>
        </modal-loader-window>
        <modal-message-window :displayModalMessage="showModalMessage">
            <template #header>
                <span v-html="modalMessageHeader"></span>
                <!-- {{ modalMessageHeader }} -->
            </template>
            <template #body>
                <span v-html="modalMessageBody"></span>
                <!-- {{ modalMessageBody }} -->
            </template>
        </modal-message-window>
    </section>
</template>

<script>
import ModalLoaderWindow from '../static_elements/ModalLoaderWindow.vue';
import ModalMessageWindow from '../static_elements/ModalMessageWindow.vue';
import {
    compressImageForUpload,
    CLIENT_COMPRESS_CONCURRENCY,
} from '@/utils/compressImageForUpload.js';
import {
    clearFileInput,
    filesFromFileInput,
    pickImages,
    takeCameraPhoto,
    PICK_IMAGES_MAX_FILES,
} from '@/utils/imagePicker.js';
import { isNativeApp } from '@/utils/platform';
import { subscribeNetworkStatus } from '@/utils/networkStatus';
import {
    messageForUploadError,
    newClientId,
    uploadProtocolWithImageChunks,
} from '@/utils/protocolUpload.js';
import { rotateImageFile } from '@/utils/rotateImage.js';
import { formatLocalProtocolDateTime } from '@/utils/localDateTime.js';

import { useToast } from 'vue-toastification';

export default {
    components: {
        // imageCompressor
        ModalLoaderWindow,
        ModalMessageWindow,
    },
    // props:['closeModalLoaderBtn'],
    data() {
        return {
            reportDate: null,
            objektName: '',
            protokolType: '',
            reportPict: null,
            previewImage: null,
            displayStatus: 'hidden',
            file: '',
            // For preview (data-URLs) + matching File/Blob for upload (no base64 roundtrip)
            preview_list: [],
            preview_files: [],
            image_list: [],
            // Draggable
            draggableList: [],
            startDrop: '',
            touchDrag: null,
            formData: new FormData(),
            // Modal
            showModalLoader: false,
            showModalMessage: false,
            modalMessageHeader: '',
            modalMessageBody: '',
            percentage: 0,
            // current response Id for "Vorschau" Button
            currentPrtokolId: '',
            uploadBatchId: '',
            toast: useToast(),
            isOnline: null,
            rotatingIndexes: {},

        };
    },
    computed: {
        isBestandsaufnahme() {
            return this.$route.query.lockedType === 'Bestandsaufnahme';
        },
        isNativePicker() {
            return isNativeApp();
        },
    },
    watch: {
        previewImage() {
            if (this.previewImage !== null) {
                this.displayStatus = '';
            }
        },
    },
    created() {
        if (this.isBestandsaufnahme) {
            this.protokolType = 'Bestandsaufnahme';
        }
    },

    methods: {
        startDrag(event, index) {
            this.startDrop = index;
        },
        swapImages(from, target) {
            if (
                from == null ||
                target == null ||
                from === target ||
                from < 0 ||
                target < 0 ||
                from >= this.preview_list.length ||
                target >= this.preview_list.length
            ) {
                return;
            }
            const nextPreview = [...this.preview_list];
            const nextFiles = [...this.preview_files];
            const temPreview = nextPreview[from];
            nextPreview[from] = nextPreview[target];
            nextPreview[target] = temPreview;
            const temFile = nextFiles[from];
            nextFiles[from] = nextFiles[target];
            nextFiles[target] = temFile;
            this.preview_list = nextPreview;
            this.preview_files = nextFiles;
        },
        onDrop(event, target) {
            event.preventDefault();
            this.swapImages(this.startDrop, target);
            this.startDrop = '';
        },
        clearTouchDragStyles() {
            document
                .querySelectorAll(
                    '.previewImgContainer.is-dragging, .previewImgContainer.drop-target',
                )
                .forEach((node) => {
                    node.classList.remove('is-dragging', 'drop-target');
                });
        },
        clearTouchDragTimer() {
            if (this.touchDrag && this.touchDrag.longPressTimer) {
                clearTimeout(this.touchDrag.longPressTimer);
                this.touchDrag.longPressTimer = null;
            }
        },
        onTouchStart(event, imageIndex) {
            if (event.target.closest('.display-delete-icon, .display-rotate-icon')) return;
            const touch = event.touches[0];
            if (!touch) return;
            const sourceEl = event.currentTarget;
            this.touchDrag = {
                startIndex: imageIndex,
                startX: touch.clientX,
                startY: touch.clientY,
                active: false,
                sourceEl,
                longPressTimer: setTimeout(() => {
                    if (!this.touchDrag || this.touchDrag.sourceEl !== sourceEl) {
                        return;
                    }
                    this.touchDrag.active = true;
                    this.touchDrag.sourceEl.classList.add('is-dragging');
                    if (navigator.vibrate) {
                        navigator.vibrate(12);
                    }
                }, 280),
            };
        },
        onTouchMove(event) {
            if (!this.touchDrag) return;
            const touch = event.touches[0];
            if (!touch) return;
            const dx = touch.clientX - this.touchDrag.startX;
            const dy = touch.clientY - this.touchDrag.startY;

            // Vor dem Long-Press: bei Bewegung als Scroll werten und abbrechen
            if (!this.touchDrag.active) {
                if (Math.abs(dx) + Math.abs(dy) > 10) {
                    this.clearTouchDragTimer();
                    this.touchDrag = null;
                }
                return;
            }

            event.preventDefault();
            this.clearTouchDragStyles();
            this.touchDrag.sourceEl.classList.add('is-dragging');
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            const wrapper =
                el && el.closest ? el.closest('.previewImgContainer') : null;
            if (wrapper && wrapper !== this.touchDrag.sourceEl) {
                wrapper.classList.add('drop-target');
            }
        },
        onTouchEnd(event) {
            if (!this.touchDrag) return;
            this.clearTouchDragTimer();
            const drag = this.touchDrag;
            this.touchDrag = null;
            this.clearTouchDragStyles();
            if (!drag.active) return;
            const touch = event.changedTouches[0];
            if (!touch) return;
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            const wrapper =
                el && el.closest ? el.closest('.previewImgContainer') : null;
            if (!wrapper || wrapper === drag.sourceEl) return;
            const targetIndex = Number(wrapper.dataset.imageIndex);
            if (Number.isNaN(targetIndex)) return;
            this.swapImages(drag.startIndex, targetIndex);
        },
        onTouchCancel() {
            this.clearTouchDragTimer();
            this.touchDrag = null;
            this.clearTouchDragStyles();
        },
        closeModalLoader() {
            this.showModalLoader = false
        },

        saveReport() {
            if (
                this.objektName !== '' ||
                this.protokolType !== '' ||
                this.reportPict !== ''
            ) {
                console.log('saveReport after if function');
            }
        },
        async pickFromGallery() {
            try {
                const files = await pickImages({ input: this.$refs.fileInput });
                await this.ingestPickedFiles(files);
            } catch (err) {
                console.error(err);
                this.toast.error('Galerie konnte nicht geöffnet werden.', {
                    timeout: 2000,
                });
            }
        },
        async pickFromCamera() {
            try {
                const files = await takeCameraPhoto();
                await this.ingestPickedFiles(files);
            } catch (err) {
                console.error(err);
                this.toast.error('Kamera konnte nicht geöffnet werden.', {
                    timeout: 2000,
                });
            }
        },
        async requestUploadFile(event) {
            const files = filesFromFileInput(event.target);
            await this.ingestPickedFiles(files, event.target);
        },
        async ingestPickedFiles(files, input) {
            if (!files.length) {
                if (input) {
                    clearFileInput(input);
                }
                return;
            }
            // Samsung Internet feuert `change` am Datei-Input gelegentlich doppelt.
            // Die zweite Runde würde dieselben Bilder noch einmal an die Vorschau hängen.
            if (this._ingestInFlight) {
                return;
            }
            this._ingestInFlight = true;
            this.showModalLoader = true;
            this.previewImage = 1;
            this.file = files[0];
            try {
                const maxFiles = PICK_IMAGES_MAX_FILES;
                if (files.length > maxFiles) {
                    this.toast.warning(
                        `Bitte maximal ${maxFiles} Bilder auswählen.`,
                        {
                            timeout: 2000,
                        },
                    );
                    return;
                }

                const concurrency = CLIENT_COMPRESS_CONCURRENCY;
                let done = 0;
                for (let start = 0; start < files.length; start += concurrency) {
                    const chunk = files.slice(start, start + concurrency);
                    const prepared = await Promise.all(
                        chunk.map(async (file) => {
                            const compressed = await compressImageForUpload(file);
                            return {
                                compressed,
                                url: URL.createObjectURL(compressed),
                            };
                        }),
                    );
                    for (const item of prepared) {
                        this.preview_list.push(item.url);
                        this.preview_files.push(item.compressed);
                        this.draggableList.push({
                            index: this.preview_list.length - 1,
                            item: item.url,
                        });
                        done += 1;
                        this.calcPercentage(done, files.length);
                    }
                }
            } catch (err) {
                console.error(err);
                this.toast.error('Bilder konnten nicht vorbereitet werden.', {
                    timeout: 2000,
                });
            } finally {
                this._ingestInFlight = false;
                if (input) {
                    clearFileInput(input);
                }
                this.showModalLoader = false;
            }
        },
        calcPercentage(uplodedFiles, total) {
            return (this.percentage =
                Math.round((uplodedFiles / total) * 100).toString() + '%');
        },
        async uploadFiles(prStatus) {
            if (this._uploadInFlight) {
                return;
            }
            if (this.objektName === '' || this.protokolType === '') {
                this.toast.warning('Objekt und Protokolltyp können nicht leer sein', { timeout: 4000 });
                return;
            }
            this._uploadInFlight = true;
            this.showModalMessage = true;
            this.modalMessageHeader = 'Protokoll hochladen';
            this.modalMessageBody = 'Dies kann ein paar Minuten dauern.';

            // Web und native App: mehrere Auswahlen summieren sich in der Vorschau.
            // Multer lehnt einen Request mit mehr als 100 Dateien ab (LIMIT_FILE_COUNT).
            try {
                await this.uploadFilesChunked(prStatus);
            } finally {
                this._uploadInFlight = false;
            }
        },
        protocolFieldPayload(prStatus) {
            const dateAndTime = formatLocalProtocolDateTime(new Date());
            const fields = {
                date: this.reportDate,
                dtCreate: dateAndTime,
                objekt: this.objektName,
                type: this.protokolType,
                status: prStatus,
                userName: this.$store.state.auth.user.login,
            };
            if (prStatus === 'Abgeschlossen') {
                fields.dtClose = dateAndTime;
            }
            return fields;
        },
        removeUploadedPreviewPrefix(count) {
            const n = Math.max(0, Math.min(count, this.preview_files.length));
            for (let i = 0; i < n; i += 1) {
                this.revokePreviewUrl(this.preview_list[i]);
            }
            this.preview_list = this.preview_list.slice(n);
            this.preview_files = this.preview_files.slice(n);
        },
        async uploadFilesChunked(prStatus) {
            this.modalMessageBody = 'Bilder werden in Blöcken hochgeladen…';
            try {
                const result = await uploadProtocolWithImageChunks({
                    protocolId: this.currentPrtokolId || undefined,
                    fields: this.protocolFieldPayload(prStatus),
                    files: this.preview_files,
                    finalStatus: prStatus,
                    clientBatchId: this.ensureUploadBatchId(),
                    onProgress: (done, total, label) => {
                        this.calcPercentage(done, total);
                        this.modalMessageBody = label;
                    },
                });
                this.currentPrtokolId = result.protocolId;
                this.removeUploadedPreviewPrefix(result.uploadedFiles.length);

                if (result.statusFailed) {
                    this.showModalMessage = false;
                    this.modalMessageHeader = '';
                    this.modalMessageBody = '';
                    this.toast.warning(
                        'Bilder sind gespeichert. Der Abschluss ist fehlgeschlagen — bitte erneut auf Abschließen tippen.',
                        { timeout: 6000 },
                    );
                    return;
                }

                if (!result.complete) {
                    this.showModalMessage = false;
                    this.modalMessageHeader = '';
                    this.modalMessageBody = '';
                    const left = result.remainingFiles.length;
                    const detail = messageForUploadError(result.error);
                    const base = `Teilweise hochgeladen. ${left} Bild(er) noch offen — bitte erneut senden.`;
                    this.toast.warning(detail ? `${base} ${detail}` : base, {
                        timeout: 5000,
                    });
                    return;
                }

                if (prStatus === 'Abgeschlossen') {
                    this.toast.success(
                        'Protokoll wurde erfolgreich abgeschlossen!',
                        { timeout: 3000 },
                    );
                }
                this.modalMessageHeader =
                    '<h1 style="color:green">Protokol Status!</h1>';
                this.modalMessageBody =
                    'Prtokol wurde erfolgreich hochgeladen!';
                setTimeout(() => {
                    this.showModalMessage = false;
                }, 1000);
                this.clearReport();
                if (prStatus === 'Abgeschlossen') {
                    this.$router.push('/home');
                } else {
                    this.protokoListPreview();
                }
            } catch (error) {
                this.toast.warning(this.uploadFailureMessage(error), {
                    timeout: 5000,
                });
                this.showModalMessage = false;
                this.modalMessageHeader = '';
                this.modalMessageBody = '';
                console.log(error);
            }
        },
        uploadFailureMessage(error) {
            return (
                messageForUploadError(error) ||
                'Prtokol wurde nicht erfolgreich hochgeladen! Bitte kontaktieren Sie Ihren Administrator'
            );
        },
        ensureUploadBatchId() {
            if (!this.uploadBatchId) {
                this.uploadBatchId = newClientId();
            }
            return this.uploadBatchId;
        },
        fileSizeInMB(file) {
            let fileSize = (file.size / 1000000).toFixed(2);
            return fileSize.toString() + ' MB';
        },
        isLt2Mb(file) {
            return file.size / 1024 / 1024 < 2;
        },
        revokePreviewUrl(url) {
            if (typeof url === 'string' && url.startsWith('blob:')) {
                try {
                    URL.revokeObjectURL(url);
                } catch (err) {
                    // ignore
                }
            }
        },
        clearReport() {
            this.formData = new FormData();
            this.preview_list.forEach((url) => this.revokePreviewUrl(url));
            this.preview_list = [];
            this.preview_files = [];
            this.image_list = [];
            this.uploadBatchId = '';
        },
        currentDate() {
            const now = new Date();
            this.reportDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        },
        // mouseOverText(e) {

        // },
        deleteImage(index) {
            if (index > -1) {
                this.revokePreviewUrl(this.preview_list[index]);
                this.preview_list.splice(index, 1);
                this.preview_files.splice(index, 1);
            }
        },
        async rotatePreviewImage(index) {
            const file = this.preview_files[index];
            if (!file || this.rotatingIndexes[index]) {
                return;
            }
            this.rotatingIndexes = { ...this.rotatingIndexes, [index]: true };
            try {
                const uploadId = file.uploadId;
                const rotated = await rotateImageFile(file, 90);
                if (uploadId) {
                    rotated.uploadId = uploadId;
                }
                this.revokePreviewUrl(this.preview_list[index]);
                const nextPreview = [...this.preview_list];
                const nextFiles = [...this.preview_files];
                nextPreview[index] = URL.createObjectURL(rotated);
                nextFiles[index] = rotated;
                this.preview_list = nextPreview;
                this.preview_files = nextFiles;
            } catch (err) {
                console.error(err);
                this.toast.error('Bild konnte nicht gedreht werden.', {
                    timeout: 2000,
                });
            } finally {
                const next = { ...this.rotatingIndexes };
                delete next[index];
                this.rotatingIndexes = next;
            }
        },
        protokoListPreview() {
            this.$router.push({
                name: 'displayProtokol',
                params: {
                    itemId: this.currentPrtokolId,
                    status: 'In Bearbeitung',
                },
                query: {
                    from: 'In Bearbeitung',
                },
            });
        },
        handleConnectionChange(connected) {
            this.isOnline = connected;

            if (!this.isOnline) {
                this.toast.warning(
                    'Es besteht keine Verbindung zum Netz. Bitte überprüfen Sie die Netzwerkverbindung!',
                    {
                        timeout: 2000,
                    },
                );
            }
        },
    },
    mounted() {
        this.currentDate();
        this.unsubscribeNetwork = subscribeNetworkStatus(this.handleConnectionChange);
    },
    beforeUnmount() {
        if (this.unsubscribeNetwork) {
            this.unsubscribeNetwork();
        }
        this.clearTouchDragTimer();
        this.touchDrag = null;
        this.clearTouchDragStyles();
        this.preview_list.forEach((url) => this.revokePreviewUrl(url));
    }
};

</script>

<style scoped>
.warning {
    position: fixed;
    z-index: 15;
    top: 0;
    left: 0;
    right: 0;
    background-color: yellow;
    text-align: center;
    padding: 10px;
}

section {
    margin-top: var(--app-header-height);
    padding: 0.85rem 0 0;
    box-sizing: border-box;
}

form {
    border-radius: 16px;
    width: min(42rem, 92vw);
    margin: 0 auto calc(6.75rem + var(--app-footer-height));
    background-color: #1c335a;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding: 1.25rem 1.75rem 1rem;
    color: white;
    gap: 0.15rem;
    box-sizing: border-box;
}

form > p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
    line-height: 1.2;
}

label {
    margin-top: 0.45rem;
    font-size: 1rem;
    line-height: 1.2;
    width: 100%;
    max-width: 28rem;
}

input,
select {
    margin: 0.1rem 0;
    position: relative;
    width: 100%;
    max-width: 28rem;
    height: 2.5rem;
    font-size: 1rem;
}

button {
    align-items: center;
    background-color: white;
    border: 3px solid #264271;
    border-radius: 12px;
    box-sizing: border-box;
    color: #000000;
    cursor: pointer;
    display: flex;
    font-family: Inter, sans-serif;
    font-size: 1rem;
    justify-content: center;
    line-height: 1.4;
    max-width: 100%;
    padding: 0.65rem 1.1rem;
    text-decoration: none;
    transition: all 0.2s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    width: 100%;
    max-width: 24rem;
    margin-top: 0.35rem;
}

button:active,
button:hover {
    outline: 0;
}

button:hover {
    background-color: #264271;
    color: white;
    border-color: rgba(255, 255, 255, 0.5);
}

/* Uploader */

.card-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
    max-width: 28rem;
}

.imagePreviewWrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 10px;
    cursor: pointer;
    /* margin: 0 auto 30px; */
    margin-top: 30px;
    background-size: cover;
    background-position: center center;
}

.previewImgContainer:nth-child(-n + 6) {
    flex: 0 0 45%;
    margin: 10px;
    position: relative;
}

.previewImgContainer {
    flex: 0 0 30%;
    margin: 5px;
    position: relative;
    cursor: grab;
    touch-action: pan-y;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
}

.previewImgContainer img {
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    pointer-events: none;
}

.previewImgContainer.is-dragging {
    opacity: 0.55;
    touch-action: none;
    cursor: grabbing;
}

.previewImgContainer.drop-target {
    outline: 2px solid #ffffff;
    outline-offset: -2px;
}

.previewImgContainer.is-rotating {
    opacity: 0.55;
}

.display-index,
.display-delete-icon,
.display-rotate-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    /* border: 2px solid rgb(103, 103, 103); */
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(38, 66, 113, 0.8);
    font-size: 0.9rem;
    top: 0.4rem;
    right: 0.4rem;
    margin: 0;
    z-index: 2;
    cursor: pointer;
}

.display-delete-icon {
    right: calc(0.4rem + 30px + 0.25rem);
}

.display-rotate-icon {
    right: auto;
    left: 0.4rem;
}

.card {
    border: 3px solid white;
    background-color: #264271;
    display: table;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    min-width: unset;
    border-radius: 15px;
    padding: 0.85rem;
    min-height: auto;
    position: relative;
}

.card button {
    outline: 0;
    border: 0;
    -webkit-appearence: none;
    background: white;
    color: #264271;
    border-radius: 4px;
    transition: 0.3s;
    cursor: pointer;
    font-weight: 400;
    font-size: 1.1rem;
    padding: 0.45rem 0.85rem;
}

form button:disabled {
    background-color: none;
}

.card button:hover {
    font-size: 1.15rem;
}

.card button:active {
    transform: translateY(5px);
}

.drag-area {
    min-height: 6rem;
    width: 100%;
    margin-top: 0.5rem;
    border-radius: 5px;
    border: 2px dashed #d5d5e1;
    color: #c8c9dd;
    position: relative;
    background: #dfe3f259;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0.5rem;
}

.drag-area label {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.top {
    top: 0;
    padding: 0.35rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.top p {
    font-size: 1.1rem;
    margin: 0;
}

.drag-area input {
    display: none;
}

.drag-area label {
    cursor: pointer;
}

.native-pick-actions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    max-width: 18rem;
    padding: 0.35rem 0;
}

.card .native-pick-btn {
    width: 100%;
    max-width: none;
    margin: 0;
    background: #264271;
    color: #fff;
    border: 2px solid #fff;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    padding: 0.7rem 1rem;
}

.card .native-pick-btn:hover,
.card .native-pick-btn:active {
    background: #fff;
    color: #264271;
    font-size: 1rem;
}

.sort-hint {
    margin: 0.65rem 0 0;
    padding: 0 0.25rem;
    font-size: 0.85rem;
    line-height: 1.35;
    color: #d5dbe8;
    text-align: center;
}

.hidden {
    display: none;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.form-actions {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(var(--app-footer-height) + 0.5rem);
    z-index: 1040;
    width: min(42rem, 92vw);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0.65rem 1rem;
    background-color: #1c335a;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
    box-sizing: border-box;
    gap: 0.4rem;
}

.form-actions button {
    margin-top: 0;
    max-width: 100%;
}

@media (max-width: 768px) {
    section {
        padding: 0.85rem 0 0;
    }

    form {
        padding: 0.65rem 0.85rem 0.75rem;
        margin: 0 auto;
        width: min(92vw, 28rem);
        gap: 0.1rem;
    }

    form.has-image-previews {
        padding-bottom: calc(7.5rem + var(--app-footer-height));
    }

    form > p {
        font-size: 1.2rem;
        margin-bottom: 0.1rem;
    }

    label {
        margin-top: 0.3rem;
        font-size: 0.9rem;
        max-width: 100%;
    }

    input,
    select {
        min-width: 100%;
        max-width: 100%;
        height: 2.25rem;
        margin: 0.05rem 0;
    }

    button {
        font-size: 0.95rem;
        min-width: unset;
        max-width: 100%;
        padding: 0.55rem 0.85rem;
        border-width: 2px;
        border-radius: 10px;
        line-height: 1.25;
    }

    .form-actions {
        bottom: calc(var(--app-footer-height) + 0.35rem);
        width: min(92vw, 28rem);
        padding: 0.55rem 0.75rem;
        gap: 0.3rem;
    }

    .form-actions button {
        padding: 0.55rem 0.75rem;
        font-size: 0.92rem;
    }

    .imagePreviewWrapper {
        padding: 2px;
        margin-top: 0.5rem;
    }

    .previewImgContainer:nth-child(-n + 6) {
        flex: 0 0 44%;
        margin: 2px;
    }

    .previewImgContainer {
        flex: 0 0 31%;
        margin: 2px;
    }

    .display-index,
    .display-delete-icon,
    .display-rotate-icon {
        width: 1.55rem;
        height: 1.55rem;
        font-size: 0.75rem;
        top: 0.35rem;
        margin: 0;
        line-height: 1;
    }

    .display-index {
        right: 0.35rem;
    }

    .display-delete-icon {
        right: 2.1rem;
    }

    .display-rotate-icon {
        right: auto;
        left: 0.35rem;
    }

    .card-wrapper {
        margin-top: 0.9rem;
        max-width: 100%;
    }

    .card {
        padding: 0.4rem;
        border-width: 2px;
        border-radius: 12px;
    }

    .card button {
        font-size: 1rem;
        padding: 6px 10px;
    }

    .card button:hover {
        font-size: 1.05rem;
    }

    .drag-area {
        min-height: 4.5rem;
        margin-top: 0.35rem;
        padding: 0.35rem;
    }

    .container {
        width: 100%;
    }

    .top {
        padding: 0.2rem;
    }

    .top p {
        font-size: 0.95rem;
    }

    .on-drop {
        width: 90%;
        font-size: 0.8rem;
        text-align: center;
        line-height: 1.25;
    }

    .bi-camera-fill {
        width: 1.75rem;
        height: 1.75rem;
        margin-bottom: 0.2rem;
        margin-top: 0.15rem;
    }
}
</style>
